const AdobeAdaptor = (adaptorPayload) => {

  let optionsPayload = adaptorPayload.options['adobe'];

  const setWindowProps = (targetObject) => {

    let k, ref, v;
    ref = optionsPayload[targetObject];
    for (k in ref) {
      v = ref[k];
      s[k] = v;
    }

  }

  let s_code;

  if (adaptorPayload.analyticsEvent.name === 'site-page-view'){

    s.pageName = document.title;
    setWindowProps('standardEventMap');

    if (window.location.pathname === '/') {
      setWindowProps('homeEventMap');
    } else if (window.sb.siteInfo['view_type'] === 'single') {
      setWindowProps('stockDetailEventMap');
    } else if (window.sb.siteInfo['module'] === 'auto_listings') {
      setWindowProps('stockListEventMap');
    } else {
      setWindowProps('subpageEventMap');
    }

    s_code = s.t();

    if (s_code) {
      return document.write(s_code);
    }

  }

}

export { AdobeAdaptor }